import { AuthLayout, AuthShell, ResetPasswordForm } from '@features/auth';

/** Reset-password route — Type A layout wrapping the set-new-password form. */
const ResetPasswordPage = () => (
  <AuthLayout>
    <AuthShell>
      <ResetPasswordForm />
    </AuthShell>
  </AuthLayout>
);

export default ResetPasswordPage;
